/**
 * Geçmiş gün düzenleme penceresi: üye bugünden en fazla `days` gün geriye
 * kadar kayıt girebilir (sunucu grup ayarlarından en esnek sınırı verir).
 * Gelecek günler hiç düzenlenemez. Tarihler "YYYY-AA-GG" biçiminde.
 */
export const DEFAULT_EDIT_WINDOW_DAYS = 7;
export const MAX_EDIT_WINDOW_DAYS = 30;

const DAY_MS = 24 * 60 * 60 * 1000;

function toUtcDay(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ""));
  if (!match) return null;
  return Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
}

/** Pencere sınırı: sayı değilse varsayılan, 0..30 aralığına kırpılmış tam sayı. */
export function normalizeEditWindow(days) {
  const n = Number(days);
  if (days === null || days === undefined || days === "" || !Number.isFinite(n)) {
    return DEFAULT_EDIT_WINDOW_DAYS;
  }
  return Math.min(MAX_EDIT_WINDOW_DAYS, Math.max(0, Math.floor(n)));
}

/** `today`e göre `localDate` kaç gün geride (gelecekse negatif). Geçersizse null. */
export function daysBefore(localDate, today) {
  const a = toUtcDay(localDate);
  const b = toUtcDay(today);
  if (a === null || b === null) return null;
  return Math.round((b - a) / DAY_MS);
}

/** Gün düzenlenebilir mi: gelecekte değil ve pencerenin içinde. */
export function isEditableDay(localDate, today, days) {
  const diff = daysBefore(localDate, today);
  if (diff === null) return false;
  return diff >= 0 && diff <= normalizeEditWindow(days);
}
